import { MutationTree } from 'vuex'
import { LogState } from '@/modules/log/store'
import Entry from '@/modules/log/model/Entry';

export enum MutationTypes {
    AddEntry = 'entry/add',
}

const mutations: MutationTree<LogState> = {
    [MutationTypes.AddEntry]: (state, entry: Entry) => state.stack.push(entry),
}

export default mutations
